export default "__VITE_ASSET__ba8535bd__"